const setCurrentUserAction = async ({ commit }, payload) => {
  commit('setCurrentUser', payload)
}

const getCurrentUserAction = async ({ state }) => {
  const { currentUser } = state

  return currentUser
}

const setAudienceInfoAction = async ({ commit }, payload) => {
  commit('setAudienceInfo', payload)
}
export default {
  getCurrentUserAction,
  setCurrentUserAction,
  setAudienceInfoAction,
}
